export const tangibilidadElement = {
    Producto: 1,
    Servicio: 2
}